import { useState, useEffect } from "react"
import { Tabs, Spin } from "antd"

// import CustomerForm from "@/component/form/customerForm"
// import BusinessForm from "@/component/form/businessForm"
import { useNavigate } from "react-router-dom"

import styles from "./index.module.less"
import { classModuleGenerator } from "@/utils"
import $api from "@/api/index"
import { connect } from "react-redux"

const { TabPane } = Tabs

function CollegeIndex({ regionId }) {
  const classnames = classModuleGenerator(styles)
  const [collegeList, setCollege] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const request = async () => {
      const params = {
        index: 0,
        size: 50,
      }
      if (regionId) params.regionId = regionId
      const { result } = await $api.college.page(params)
      setCollege(result?.list || [])
      setLoading(false)
    }
    request()

    document
      .querySelectorAll(".ant-tabs-tab.ant-tabs-tab-disabled")
      .forEach((tapNode) => {
        tapNode.onclick = function () {
          window.openJesongChatByGroup(121, 52601)
        }
      })
  }, [regionId])
  const navigate = useNavigate()

  function toDetail(id) {
    navigate(`/college/${id}`, {
      // state 隐式传参
      // replace:true
    })
  }
  function tabCallBack(e) {
    console.log(e)
    return false
  }

  return (
    <>
      {/* <NavBar /> */}
      <div className={classnames("college-container")}>
        <div className={classnames("card-container", "section__inner")}>
          <Tabs
            defaultActiveKey="2"
            tabPosition="top"
            tabBarStyle={{ textAlign: "center" }}
            onTabClick={tabCallBack}
          >
            <TabPane key="1" tab="预约到校" disabled>
              {/* <CustomerForm /> */}
            </TabPane>
            <TabPane key="2" tab="中职院校">
              <div style={{ textAlign: "center" }}>{loading && <Spin />}</div>
              <ul className={`${styles["collegeList"]} clearfix`}>
                {collegeList.map((model) => {
                  return (
                    <li
                      key={model._id}
                      className={styles.collegeItem}
                      onClick={() => toDetail(model._id)}
                    >
                      <img src={model.coverUrl} alt="" />
                      <h5>{model.name}</h5>
                      {/* <p className="college__address">{model.address}</p>
                      <button onClick={() => toDetail(model._id)}>
                        了解详情
                      </button> */}
                      {/* <Link to={`/college/${model._id}`}>了解详情</Link> */}
                    </li>
                  )
                })}
              </ul>
            </TabPane>
            <TabPane key="3" tab="合作模式" disabled>
              {/* <BusinessForm /> */}
            </TabPane>
          </Tabs>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    regionId: state.region.checked._id,
  }
}

export default connect(mapStateToProps)(CollegeIndex)